import { render, staticRenderFns } from "./CompetitionListComponent.vue?vue&type=template&id=0fa72c40&scoped=true&"
import script from "./CompetitionListComponent.vue?vue&type=script&lang=js&"
export * from "./CompetitionListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa72c40",
  null
  
)

export default component.exports